import { Button, Card, Form, Input, message, Modal } from "antd";
import { useEffect, useState } from "react";
import apiClient from "../../../services/api";
import { CategoryFeature } from "../../../Types/CategoryFeature";

import { ModificatorType } from "../Types/ModificatorType";
import { visibilityRules } from "../Helpers/visibilityRules";
import { FormInputSelector } from "./FormInputSelector";
import { useModifications } from "../Hooks/useModifications";

interface FeatureModificatorProps {
  featureCategory: ModificatorType;
  updateNotes: (groupType: number, value: any) => void;
}
export const FeatureModificator = ({
  featureCategory,
  updateNotes,
}: FeatureModificatorProps) => {
  const [inputCache, setInputCache] = useState<Record<string, any>>({});

  const [options, setOptions] = useState<CategoryFeature[]>([]);

  const { featureGroup, removeCategory, updateItems } = useModifications();

  const getOptions = async () => {
    const { data: options } = await apiClient.get("/vehicle-features");

    const rule = visibilityRules.find(
      (rule) => rule.id === featureCategory.type
    );
    const hiddenIds = rule?.hiddenFeatures || [];
    const filteredOptions = options.filter(
      (option: CategoryFeature) => !hiddenIds.includes(option.id)
    );

    setOptions(filteredOptions);
  };
  useEffect(() => {
    if (featureCategory.type) {
      getOptions();
    }
  }, [featureCategory.type]);

  const findValue = (groupType, featureId) => {
    const group = featureGroup.find((group) => group.type == groupType);

    if (group) {
      const value =
        group.data.find((feature) => feature.id == featureId)?.value ||
        undefined;

      return value;
    }
  };

  const onRemove = (categoryId: number) => {
    Modal.confirm({
      content: "¿Seguro de eliminar este grupo?",
      title: "Confirmar",
      onOk: () => {
        removeCategory(categoryId);
      },
      onCancel: () => {},
    });
  };

  return (
    <Card
      className="cardex"
      title={`Cambios ${featureCategory.name}`}
      style={{ marginTop: 20 }}
      extra={
        <Button onClick={() => onRemove(featureCategory.type)} danger>
          X
        </Button>
      }
    >
      <div className="custom_form">
        {options.map((feature, i) => {
          const key = `${featureCategory.type}_${feature.id}`;
          const controlledValue =
            key in inputCache
              ? inputCache[key]
              : findValue(featureCategory.type, feature.id);

          return (
            <div
              key={key}
              className={`input-modificator ${controlledValue ? "active" : ""}`}
            >
              <span className="label">{feature.name}</span>
              <FormInputSelector
                value={controlledValue}
                featureId={feature.id}
                categoryId={featureCategory.type}
                onChange={(value) => {
                  setInputCache((prev) => ({ ...prev, [key]: value }));
                  updateItems({
                    groupType: featureCategory.type,
                    featureId: feature.id,
                    value,
                  });
                }}
              />
            </div>
          );
        })}
      </div>

      {/* {featureCategory.type == 2 && (
        <Input.TextArea
          value={ADECUACION_DEFAULT_NOTE}
          style={{ margin: 10, background: "whitesmoke" }}
          readOnly
          onChange={(e) => updateNotes(featureCategory.type, e.target.value)}
          size="middle"
        />
      )} */}
    </Card>
  );
};
